import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import '../../styles/Blog.css';

const BlogPostPage = () => {
    const { slug } = useParams();
    const [post, setPost] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPost = async () => {
            try {
                const response = await fetch(`/api/blog/post/${slug}`);
                if (!response.ok) {
                    throw new Error('Post not found');
                }
                const data = await response.json();
                setPost(data);

                // SEO: Set title and description
                document.title = `${data.title} - WizeHelper Blog`;
                let metaDescription = document.querySelector("meta[name='description']");
                if (!metaDescription) {
                    metaDescription = document.createElement('meta');
                    metaDescription.name = 'description';
                    document.head.appendChild(metaDescription);
                }
                // Use the first 150 chars of content as description
                metaDescription.content = data.content.substring(0, 155) + '...';

            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchPost();
    }, [slug]);

    if (loading) return <div className="spinner-container"><div className="spinner"></div></div>;
    if (error) return (
        <div className="blog-page-container">
            <div className="error">Error: {error}</div>
            <Link to="/blog" className="back-link">&larr; Back to Blog</Link>
        </div>
    );

    if (!post) return null;

    return (
        <main className="mx-auto px-6 py-8" style={{ maxWidth: '88rem' }}>
            <div className="single-post-container !max-w-none">
                <Link to="/blog" className="back-link">&larr; Back to Blog</Link>

                <article>
                    <header className="post-header">
                        <h1 className="single-post-title">{post.title}</h1>
                        <div className="post-meta">
                            <span> • Created: {new Date(post.createdAt).toLocaleDateString()}</span>
                            {post.view_count !== undefined && (
                                <div className="post-tags">
                                    <span> • Views: {post.view_count}</span>
                                </div>
                            )}
                            {post.tags && post.tags.length > 0 && (
                                <div className="post-tags">
                                    {post.tags.map(tag => (
                                        <span key={tag} className="post-tag">• Tags: #{tag}</span>
                                    ))}
                                </div>
                            )}
                        </div>
                    </header>

                    <div className="post-content prose prose-lg dark:prose-invert max-w-none">
                        <ReactMarkdown>
                            {post.content.replace(/\\n/g, '\n').replace(/^#\s.*$/m, '')}
                        </ReactMarkdown>
                    </div>
                </article>
            </div>
        </main>
    );
};

export default BlogPostPage;
